module.exports = __webpack_public_path__ + "static/media/menu.f2802a8e.svg";